import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import OffersDividedList from "./OffersDividedList";


function OffersDivided(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const curIndex = gVal("offersDealing", false, -1);
    const tenderCompleted = (index) => {
        const decision = getObjectValue("form.tenderCompletionData.divided." + index + ".tenderCompletionType", formikProps.values, null);
        return !!decision && decision !== "nieRozstrzygnieto";
    }

    return (<FieldArray
        name={gId("divided")}
        render={() => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="offersDealing"
                items={gVal("divided", true, [])}
                hideItem={(index) => !tenderCompleted(index)}
            />
            {curIndex > -1 &&
                <OffersDividedList
                    formikProps={formikProps}
                    id={gId("divided." + curIndex)}
                    index={curIndex}
                />
            }

        </>)}
    />)
}

OffersDivided.propTypes = {};

export default OffersDivided;
